import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FilmService } from "../../services/film.service";
import { PersonService } from "../../services/person.service";
import { ContentService } from "../../services/content.service";
import { FilmModel } from '../../models/film';
import { PersonModel } from '../../models/person';
import { ContentModel } from "../../models/content";
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from "@angular/common";
import 'rxjs/add/operator/switchMap';

@Component({
  moduleId: module.id,
  selector: 'site-videoFilmReviewPage',
  templateUrl: './videoFilmReviewPage.component.html',
  styleUrls: ['./videoFilmReviewPage.component.css']
})
export class VideoFilmReviewPage implements OnInit {
  film: FilmModel;

  constructor(private filmService:FilmService, private personService:PersonService, private contentService:ContentService, private router: Router, private route: ActivatedRoute, private location: Location)
  {
  }

  contentInfo: ContentModel;
  contentID: number;

  ngOnInit(): void{
    this.route.params.switchMap((params: Params) => {
      this.contentID = +params["id"];
      return this.getContent(this.contentID);
    }).subscribe(r =>{
      this.content = r;
      this.content.publishDate = new Date(this.content.publishDate);

      this.getFilm(this.content.filmsDiscussed[0].filmID).subscribe(r =>{
        this.film = r;
        this.film.releaseDate = new Date(this.film.releaseDate);
      });
    });

    this.getContent(this.contentID).subscribe(c =>{
      this.contentInfo = c;
    });



    // this.getFilm(1).subscribe(r =>{
    //   this.film = r;
    //   this.film.releaseDate = new Date(this.film.releaseDate);
    // });

    // console.log(this.person);
    // this.getContent(5).subscribe(r =>{
    //   this.content = r;
    //   this.content.publishDate = new Date(this.content.publishDate);
    // });
    // console.log(this.content);
  }

  private getFilm(index: number): Observable<FilmModel>
  {
    return this.filmService.getFilm(index).map((v,i)=>v);
  }

  private formatReleaseDate(): string 
  {
    let monthNames: string[] = 
    [
    "January", "February", "March",
    "April", "May", "June", "July",
    "August", "September", "October",
    "November", "December"
    ];
    let day: number = this.film.releaseDate.getDate();
    let monthIndex: number = this.film.releaseDate.getMonth();
    let year: number = this.film.releaseDate.getFullYear();

    return monthNames[monthIndex] + ' ' + day + ', ' + year;
  }

  private formatStars(): string
  {
    let numStars: number = this.film.paulEntertainment;
    let entertainmentStars: string = "";

    for (let i:number = 1; i<= 4; i++)
    {
      if (i<=numStars)
      {
        entertainmentStars += "&#9733; "
      }
      else
      {
        entertainmentStars += "&#9734; "
      }
    }
    return entertainmentStars;
  }

  private formatGenreList(): string
  {
    let genreString: string = "";
    for (let i:number = 0; i< this.film.genre.length; i++)
    {
      genreString += this.film.genre[i];
      genreString += " | "
    }
    return genreString.substring(0,genreString.length - 3);
  }

  person: PersonModel;

  private getPerson(index: number): Observable<PersonModel>
  {
    return this.personService.getPerson(index).map((v,i)=>v);
  }

  private getDirector(): string
  {
    let directors:string = "";
    for (let i:number = 0; i<this.film.filmmakers.length; i++)
    {
      for (let t:number = 0; t<this.film.filmmakers[i].filmmakerRoles.length; t++)
      {
        if (this.film.filmmakers[i].filmmakerRoles[t].roleName === "Director")
        {
          let directorName:string = this.film.filmmakers[i].personFirstName + " " + this.film.filmmakers[i].personLastName;
          directors += directorName + "<br/>";
        }
      }
    }
    return directors.substring(0,directors.length - 5);
  }

  private getWriter(): string
  {
    let writers:string = "";
    for (let i:number = 0; i<this.film.filmmakers.length; i++)
    {
      for (let t:number = 0; t<this.film.filmmakers[i].filmmakerRoles.length; t++)
      {
        if (this.film.filmmakers[i].filmmakerRoles[t].roleName === "Writer")
        {
          let writerName:string = this.film.filmmakers[i].personFirstName + " " + this.film.filmmakers[i].personLastName;
          writers += writerName + "<br/>";
        }
      }
    }
    return writers.substring(0,writers.length - 5);
  }

  private getCinematographer(): string
  {
    let cinematographers:string = "";
    for (let i:number = 0; i<this.film.filmmakers.length; i++)
    {
      for (let t:number = 0; t<this.film.filmmakers[i].filmmakerRoles.length; t++)
      {
        if (this.film.filmmakers[i].filmmakerRoles[t].roleName === "Cinematographer")
        {
          let cinematographerName:string = this.film.filmmakers[i].personFirstName + " " + this.film.filmmakers[i].personLastName;
          cinematographers += cinematographerName + "<br/>";
        }
      }
    }
    return cinematographers.substring(0,cinematographers.length - 5);
  }

  private getEditor(): string
  {
    let editors:string = "";
    for (let i:number = 0; i<this.film.filmmakers.length; i++)
    {
      for (let t:number = 0; t<this.film.filmmakers[i].filmmakerRoles.length; t++)
      {
        if (this.film.filmmakers[i].filmmakerRoles[t].roleName === "Editor")
        {
          let editorName:string = this.film.filmmakers[i].personFirstName + " " + this.film.filmmakers[i].personLastName;
          editors += editorName + "<br/>";
        }
      }
    }
    return editors.substring(0,editors.length - 5);
  }

  private getMusician(): string
  {
    let musicians:string = "";
    for (let i:number = 0; i<this.film.filmmakers.length; i++)
    {
      for (let t:number = 0; t<this.film.filmmakers[i].filmmakerRoles.length; t++)
      {
        if (this.film.filmmakers[i].filmmakerRoles[t].roleName === "Music By")
        {
          let directorName:string = this.film.filmmakers[i].personFirstName + " " + this.film.filmmakers[i].personLastName;
          musicians += directorName + "<br/>";
        }
      }
    }
    return musicians.substring(0,musicians.length - 5);
  }

  private getStars(): string[]
  {
    let stars: string[] = new Array();
    
    for (let i:number = 0; i<this.film.filmmakers.length; i++)
    {
      for (let t:number = 0; t<this.film.filmmakers[i].filmmakerRoles.length; t++)
      {
        if (this.film.filmmakers[i].filmmakerRoles[t].roleType === "Starring")
        {
          let starName:string = "";
          stars.push(this.film.filmmakers[i].personFirstName + " " + this.film.filmmakers[i].personLastName);
          stars.push(this.film.filmmakers[i].filmmakerRoles[t].roleName);
        }
      }
    }
    return stars;
  }

  content: ContentModel;  

  private getContent(index: number): Observable<ContentModel>
  {
    return this.contentService.getContent(index).map((v,i)=>v);
  }

  private formatPublishDate(): string 
  {
    let monthNames: string[] = 
    [
    "January", "February", "March",
    "April", "May", "June", "July",
    "August", "September", "October",
    "November", "December"
    ];
    let day: number = this.content.publishDate.getDate();
    let monthIndex: number = this.content.publishDate.getMonth();
    let year: number = this.content.publishDate.getFullYear();

    console.log("THIS IS THE DATE");
    console.log(this.content.publishDate);
    console.log(this.film.releaseDate);

    return monthNames[monthIndex] + ' ' + day + ', ' + year;
  }

  private getReferences(): string
  {
    let referencesString: string = "";

    for(let i: number = 0; i<this.content.references.length; i++)
    {
      referencesString += "<div class=\"articleReference\">" +
      this.content.references[i] +
      "</div>" +
      "</br>";
    }
    return referencesString;
  }

  private getVideoLink(): string
  {
    let videoString: string = "";
    videoString += "<iframe width=\"100%\" height=\"100%\" frameBorder=\"0\" src=\"" 
    + this.content.contentData 
    + "\">" 
    + "</iframe>";
    
    console.log(videoString);
    return videoString;
  }

}



// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/components/videoFilmReviewPage/videoFilmReviewPage.component.ts